import './filter-form.scss';

/**
 * version    1.0
 * class      <type> (FilterForm)
 * classdesc   FilterForm
 */
export class FilterForm {}
